import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { SET_ALERTS_CONFIG } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { setAlertsConfig } = appStoreLenses

export default config => async (dispatch, getState) => {
	const state = getState()
	const lambdaRes = await invokeApiRequest(SET_ALERTS_CONFIG, config, state)
	const { body } = lambdaRes
	return setAlertsConfig(body, state)
}
